Object.defineProperty(exports, "__esModule", { value: true });
exports.argRegistry = void 0;
const DeepWeakMap_1 = require("../../services/utils/deepWeakMap/DeepWeakMap");
exports.argRegistry = new DeepWeakMap_1.DeepWeakMap();
//# sourceMappingURL=registry.js.map